import { Component, OnInit, ViewChild,ElementRef } from '@angular/core';
import { CollegerequestreportService } from './collegerequestreport.service';
import { CollegeWiseRegisterReport } from '../Models/collegewiserequestdetailreport.model';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router";
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { global } from '../../shared/global';
import { DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import htmlToPdfmake from 'html-to-pdfmake';
  

declare var $: any;

@Component({
  selector: 'app-collegerequestreport',
  templateUrl: './collegerequestreport.component.html',
  styleUrls: ['./collegerequestreport.component.css']
})
export class CollegerequestreportComponent implements OnInit {
  title = 'htmlToPDF';
  @ViewChild('collegewiseForm') collegewiseForm: NgForm;
  @ViewChild('pdfTable') pdfTable: ElementRef;
  //@ViewChild('TABLE', { static: false }) TABLE: ElementRef;
  data: CollegeWiseRegisterReport;
  responseData: any;
  dropDownData: any;
  collegeregistrationlist: Array<any>;
  Trusteecollegewiselist: Array<any>;
  Principalcollegewiselist: Array<any>;
 employeecollegewiselist: Array<any>;
 employeequalificationcollegewiselist: Array<any>;
 standardcollegewiselist: Array<any>;
 FeesIncreaseDetaillist : Array<any>;
 //AllocatedFeescollDetail: Array<any>;
 schoolregistercollegelist:Array<any>;
 pendingbookcollewiselist :Array<any>;
 establishmentDetaillist :Array<any>;
 SchoolDocumentUpcollwiseReqList:Array<any>;
 pendingempcollwiselist:Array<any>;
 PendingExpenscollegeList:Array<any>;
 scholarshipDetcolleList:Array<any>;
 PendingRentalcollwiseList:Array<any>;
 PendingConstructioncollegewiseList:Array<any>;
 PendingInfrastructurecollegewiseList:Array<any>;
 PendingLandOwnercollList:Array<any>;
 ClassroomcollwiseList:Array<any>;
  p: number = 1;
  pageLimit = global.pageLimit;
  searchtext;
  colleges: any;
  schoolname:any;
  HashCode: string;
  Status: any;
  CollegeID:any;
  operation:any;
  pipe: any;
  constructor(private service: CollegerequestreportService, private toastr: ToastrService, private spinner: NgxSpinnerService, private router: Router, private rout: ActivatedRoute) { }

  ngOnInit(): void {
    this.data = new CollegeWiseRegisterReport();
    this.fillcollege();
    this.Status = "0";
    $('select[name="Status"]').val("0");
    $('select[name^="Status"] option:selected').attr("selected", "0");
    this.data.CollegeID;
    var dtToday = new Date();
    var month: string = (dtToday.getMonth() + 1).toString();
    var day: string = (dtToday.getDate()).toString();
    var year: string = (dtToday.getFullYear()).toString();
    if (parseInt(month) < 10)
      month = '0' + month.toString();
    if (parseInt(day) < 10)
      day = '0' + day.toString();
    var maxDate = year + '-' + month + '-' + day;
    $('#fromDate').attr('max',  maxDate);
    $('#toDate').attr('max',  maxDate);
    //if (this.data.HashCode != undefined || this.data.HashCode != "")
      this.data.fromDate = maxDate;
      this.data.toDate = maxDate;
  }

  fillcollege() {
    const data = {
    };
    this.service.fillcollege(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.colleges = this.dropDownData.dropdownlist;
        this.data.CollegeID = 0;
      });
  }
  onSubmit() {
    if (this.data.CollegeID == undefined || this.data.CollegeID == 0) {
      this.toastr.error("Please Select college");
      return
    }
    if (this.data.fromDate == undefined || this.data.fromDate == "") {
      this.toastr.error("Please from date");
      return
    }
    var fromreqdate = $("#fromDate").val();
    this.spinner.show();
    const data  = {
     // status: $("#Status").val()
     collegeid : $("#CollegeID").val(),
     status: $("#Status").val(),
     //fromDate: this.pipe.transform(fromreqdate, 'yyyy-MM-dd'),
     fromDate:$("#fromDate").val(),
     toDate:$("#toDate").val()
     
    }
    this.service.GetCollegeRegistrationList(data)
      .subscribe(data => {
        this.responseData = data;
        this.spinner.hide();
        if (this.responseData.tokenStatus == false) {
          localStorage.clear();
          this.toastr.error(this.responseData.message);
          this.router.navigate(['/aciadmin']);
        }
        if(!this.responseData.userRightsStatus){
          this.toastr.error(this.responseData.message);
          //this.router.navigate(['/aciadmin']);
          return;
        }
         this.collegeregistrationlist = null;
         this.Trusteecollegewiselist = null;
         this.Principalcollegewiselist = null;
         this.employeecollegewiselist= null;
         this.standardcollegewiselist=null;
         this.FeesIncreaseDetaillist=null;
         this.pendingbookcollewiselist = null;
         this.establishmentDetaillist=null;
         this.SchoolDocumentUpcollwiseReqList=null;
         this.pendingempcollwiselist=null;
         this.PendingExpenscollegeList=null;
         this.scholarshipDetcolleList=null;
         this.PendingRentalcollwiseList=null;
         this.PendingConstructioncollegewiseList =null;
         this.PendingInfrastructurecollegewiseList=null;
         this.PendingLandOwnercollList=null;
         this.ClassroomcollwiseList=null;
        if (this.responseData.Status == false) {
          this.toastr.error("Record does not exist!");
          document.getElementById("divclgList").style.display = "none";
          document.getElementById("btnpdf").style.display = "none";
          //document.getElementById("btnfile").style.display = "none";
        } else {
          this.collegeregistrationlist = this.responseData.CollegeWiseRegisterList;
          this.Trusteecollegewiselist = this.responseData.CollegeWiseRegisterList[0].TrusteeListcollegewise;
          this.Principalcollegewiselist = this.responseData.CollegeWiseRegisterList[0].Principalcollegewiselist;
          this.employeecollegewiselist = this.responseData.CollegeWiseRegisterList[0].EmployeeTypeDetailListcollegewise;
          this.employeequalificationcollegewiselist= this.responseData.CollegeWiseRegisterList[0].EmployeeQualificationDetaillist;
          this.standardcollegewiselist = this.responseData.CollegeWiseRegisterList[0].StandardListcollegewise;
          this.FeesIncreaseDetaillist =  this.responseData.CollegeWiseRegisterList[0].FeesIncreaseDetail;
         // this.AllocatedFeescollDetail = this.responseData.CollegeWiseRegisterList[0].AllocatedFeescollwiseList;
          this.pendingbookcollewiselist =  this.responseData.CollegeWiseRegisterList[0].PendingBookcollegewiseList;
          this.establishmentDetaillist = this.responseData.CollegeWiseRegisterList[0].PendingEstablishmentcollwiseList;
          this.SchoolDocumentUpcollwiseReqList = this.responseData.CollegeWiseRegisterList[0].SchoolDocumentUploadcollwiseReqList;
          this.pendingempcollwiselist = this.responseData.CollegeWiseRegisterList[0].pendingEmpAdditionalcollewiseList;
          this.PendingExpenscollegeList = this.responseData.CollegeWiseRegisterList[0].PendingExpenscolegeList;
          this.scholarshipDetcolleList = this.responseData.CollegeWiseRegisterList[0].ScholarshipDetcollewiseList;
          this.PendingRentalcollwiseList = this.responseData.CollegeWiseRegisterList[0].PendingRentalcollegewiseList;
          this.PendingConstructioncollegewiseList = this.responseData.CollegeWiseRegisterList[0].PendingConstructioncollwiseList;
          this.PendingInfrastructurecollegewiseList = this.responseData.CollegeWiseRegisterList[0].PendingInfracollwiseList;
          this.PendingLandOwnercollList= this.responseData.CollegeWiseRegisterList[0].PendingLandOwnercollegewiseList;
          this.ClassroomcollwiseList = this.responseData.CollegeWiseRegisterList[0].ClassroomcollegewiseList;
          document.getElementById("divclgList").style.display = "block";
         document.getElementById("btnpdf").style.display = "block";
        
        }
      });
  }

  // ExportToExcel() {
  //   const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.TABLE.nativeElement);
  //   const wb: XLSX.WorkBook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  //   XLSX.writeFile(wb, 'collegerequestreport.xlsx');
  // }

    
  downloadAsPDF() {
    if (this.data.CollegeID == undefined || this.data.CollegeID == 0) {
      this.toastr.error("Please Select college");
      return
    }
      const doc = new jsPDF();
      const pdfTable = this.pdfTable.nativeElement;
      var html = htmlToPdfmake(pdfTable.innerHTML);
      const documentDefinition = { content: html };
      pdfMake.createPdf(documentDefinition).open(); 
    }
    

   
    
}
